import { useTranslation } from 'react-i18next';

import { useModal } from '@app/components/modal-views/context';
import { Button } from '@app/shadcn/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@app/shadcn/components/ui/dropdown-menu';
import DeleteIcon from '@Components/icons/delete';
import { MoreVertical } from 'lucide-react';

const DeleteDomainDropdown = () => {
    const { t } = useTranslation();
    const { openModal } = useModal();

    return (
        <div>
            <DropdownMenu>
                <DropdownMenuTrigger asChild>
                    <Button aria-label={t('STAFF.WORKSPACE.DOMAIN_ACTIONS')} className="p-1! outline-hidden" variant={'v2GhostButton'} icon={<MoreVertical width={24} height={24} className="text-black-700" />}></Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end" className="bg-white">
                    <DropdownMenuItem
                        className="hover:bg-black-200 flex cursor-pointer items-center gap-2 outline-hidden"
                        onClick={() => {
                            openModal('DELETE_CUSTOM_DOMAIN');
                        }}
                    >
                        <DeleteIcon />
                        {t('STAFF.WORKSPACE.DELETE')}
                    </DropdownMenuItem>
                </DropdownMenuContent>
            </DropdownMenu>
        </div>
    );
};

export default DeleteDomainDropdown;
